import { BaseLogger } from '../BaseLogger';

export class GoogleAnalyticsLogger extends BaseLogger {
  log(visiting) {
    if (!this.isLogNeeded()) {
      return;
    }
    window.ga && window.ga('send', 'pageview', `virtual/${visiting}`);
  }
}
